import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Box } from '@landr/maestro';
import { CONFIG } from 'utils/config';
import { i18n } from 'utils/setupTranslations';
import { useUserProfile } from 'apollo/user';
import { useAuthentication } from 'components/AuthenticationProvider/AuthenticationProvider';
import { getAuthToken } from 'components/AuthenticationProvider/getAuthToken';
import { useI18nLocaleDetection } from 'hooks/useI18nLocaleDetection/useI18nLocaleDetection';
import { zIndex } from '../../../constants';
import { NavBar } from './LandrNavbar/LandrNavbar';
import {
    useUniversalNavBarConfig,
    useUniversalNavBarHandlers,
} from './UniversalNavBar.hooks';

const UniversalNavBarWrapper = styled(Box)`
    z-index: ${zIndex.universalNavBar};
    padding: 0;
`;

export const UniversalNavBar = (): JSX.Element => {
    useI18nLocaleDetection();

    const location = useLocation();
    const { userProfile, isUserLoading } = useUserProfile();
    const { logout, login, signup } = useAuthentication();

    const { navBarConfig, language, user } = useUniversalNavBarConfig({
        getAuthToken,
        userProfile,
        locale: i18n.locale,
    });
    const handleLogin = useUniversalNavBarHandlers(login, signup);

    return (
        <UniversalNavBarWrapper>
            <NavBar
                config={navBarConfig}
                env={CONFIG.VITE_APP_ENV}
                language={language}
                locationPathname={location.pathname}
                onLogin={handleLogin}
                onLogout={logout}
                user={user}
                hasNotifications
                isUserLoading={isUserLoading}
                isSessionsPickerVisible={true}
            />
        </UniversalNavBarWrapper>
    );
};

UniversalNavBar.displayName = 'UniversalNavBar';
